// section names
export const NAME_AND_PAGE = 'name_and_page'
export const PRIMARY_TEXT = 'primary_text'
export const MEDIA = 'media'
